/**
 * CPF e CNPJ com a pontuação de sempre (F135). O cadastro guarda só dígitos;
 * o que não tem 11 nem 14 sai como veio, em vez de uma máscara mentindo.
 */
export const formatDocument = (digits) => {
    if (digits === null)
        return null;
    const clean = digits.replace(/\D/g, '');
    if (clean.length === 11) {
        return `${clean.slice(0, 3)}.${clean.slice(3, 6)}.${clean.slice(6, 9)}-${clean.slice(9)}`;
    }
    if (clean.length === 14) {
        return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12)}`;
    }
    return digits;
};
//# sourceMappingURL=document-format.js.map